const hexToRgba = (hex, opacity = 1) => {
  const bigint = parseInt(hex.slice(1), 16);
  const r = bigint >> 16 & 255;
  const g = bigint >> 8 & 255;
  const b = bigint & 255;
  return `rgba(${r}, ${g}, ${b}, ${opacity})`;
};
const getBackgroundColor = (background_color) => {
  var _a, _b, _c, _d, _e;
  if (background_color.background_gradient_style === "linear") {
    return `linear-gradient(${(_a = background_color.background_gradient_color.color1) == null ? void 0 : _a.hex},${(_b = background_color.background_gradient_color.color2) == null ? void 0 : _b.hex})`;
  } else if (background_color.background_gradient_style === "radial") {
    return `radial-gradient(${(_c = background_color.background_gradient_color.color1) == null ? void 0 : _c.hex},${(_d = background_color.background_gradient_color.color2) == null ? void 0 : _d.hex})`;
  } else {
    return (_e = background_color.background_color) == null ? void 0 : _e.hex;
  }
};
export {
  getBackgroundColor,
  hexToRgba
};
